import React from "react";
import { withTranslation } from "react-i18next";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log("ErrorBoundary getDerivedStateFromError", error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    const apiError = sessionStorage.getItem("errorItem");
    const errorMessage = sessionStorage.getItem("errorMsg");
    const checkReload = sessionStorage.getItem("reload");
    const statusError = sessionStorage.getItem("status");
    console.log("error Message", errorMessage);
    console.log("error api error", apiError);
    console.log(statusError);
    const { t, popError } = this.props;
    if (statusError !== "409") {
      if (apiError === "true") {
        console.log("inside if condition");
        if (checkReload) {
          popError([
            {
              type: "error",
              title: "",
              message: errorMessage ? errorMessage : t("Api.Error"),
              confirmBtnText: t("Button.Confirm"),
              showCancel: true,
              onConfirm: () => window.location.reload(),
            },
          ]);
        } else {
          popError([
            {
              type: "error",
              title: "",
              message: errorMessage ? errorMessage : t("Api.Error"),
              confirmBtnText: t("Button.Confirm"),
              showCancel: true,
            },
          ]);
        }
        sessionStorage.removeItem("errorItem");
        sessionStorage.removeItem("errorMsg");
        sessionStorage.removeItem("reload");
      }
    }
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>{t("Api.Error")}.</h1>;
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
